/**
 * Which client answers are typed but not sent (BR-CP-HOME-017, DL-X-30 D18).
 *
 * An in-memory registry, deliberately: Sign Out asks "You have an unsaved answer" only while one exists, and it
 * needs to know WHETHER one exists — never what it says. Nothing here is ever written to storage, logged or sent
 * (Section 17: the marker lives in page memory only).
 *
 * Today only the query detail page registers. A screen that later gains typed client input must register here
 * too, or Sign Out will not warn for it.
 */
const pending = new Set<string>();

/** Marks (or clears) one form's answer as typed-and-unsent. `key` names the form, e.g. `query:42`. */
export function setAnswerPending(key: string, isPending: boolean): void {
  if (isPending) pending.add(key);
  else pending.delete(key);
}

/** True while any registered answer is typed and not sent. */
export function hasUnsavedAnswer(): boolean {
  return pending.size > 0;
}

/** Test helper: forget every marker. */
export function resetUnsavedAnswers(): void {
  pending.clear();
}
